// extracted by mini-css-extract-plugin
export default {"block":"CreateOrganizationArtistsBlock_block__88-cA","block__title":"CreateOrganizationArtistsBlock_block__title__7Z-+m"};